import React from 'react';

import { mdiMagnify } from '@lumapps/lumx/icons';
import { Combobox, Icon, Size } from '@lumapps/lumx/react';

import { SearchBoxOptionTypeProps } from '../../types';
import { SearchBoxOptionLabel } from '../SearchBoxOptionLabel';

/**
 * Default option for the search box
 * This is the component that will be displayed if no other condition is met.
 */
export const SearchBoxDefaultOption = ({
    suggestion,
    onSelect,
    actionProps,
    ...forwardedProps
}: SearchBoxOptionTypeProps) => {
    const label = suggestion.label || suggestion.query;
    return (
        <Combobox.Option
            before={<Icon icon={mdiMagnify} size={Size.s} />}
            value={label}
            onClick={onSelect}
            actionProps={actionProps}
            {...forwardedProps}
        >
            <SearchBoxOptionLabel label={label} />
        </Combobox.Option>
    );
};
